import emptyResources from '@translations/emptyResources.json';
import globalCZ from '@translations/global-resources/globalCZ.json';
import globalSK from '@translations/global-resources/globalSK.json';
import globalDE from '@translations/global-resources/globalDE.json';



export const resources = {
	CZ: {
		global: globalCZ,
		...emptyResources,
	},
	SK: {
		global: globalSK,
		...emptyResources,
	},
	DE: {
		global: globalDE,
		...emptyResources,
	}
} as const;